import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Row, Text, Icon } from '@/components/ui';
import { LoginForm } from '@/components/forms/LoginForm';
import { Layout } from '@/components/layout';
import { mainLogoIcon } from '@/assets';

import { Background } from '@/components/ui/Background';

export const LoginPage = () => {
  const { t } = useTranslation();

  return (
    <Layout>
      <Box
        sx={{
          p: { xs: '1.125rem 1.9375rem', xl: '3.625rem 3.8125rem' }, // 18px 31px, 58px 61px
          position: 'relative',
          zIndex: 1,
          backgroundColor: 'transparent',
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <Icon src={mainLogoIcon} />
        </Box>
        <Text
          sx={{
            color: 'primary.main',
            mb: '1.25rem', // 20px
            fontSize: '2.5rem', // 40px
            textAlign: 'center',
          }}
        >
          {t('irrigation_site_survey_header_text')}
        </Text>
        <Row justifyContent='center'>
          <LoginForm hideTitle={true} />
        </Row>
      </Box>
      <Background login={true} />
    </Layout>
  );
};
